import React, { useEffect, useState, useContext } from "react";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import companyBasedRequest from "../../../request/companyBasedRequest";
import "./staffServicesModal.css";

const StaffServicesModal = ({ isOpen, onClose, shopId, shopServices = [], staffServices = [], onSave }) => {
    const { language, userData, setUserData } = useContext(CombinedContext);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        if (!isOpen) return;
        if (!shopServices || shopServices.length === 0) return;

        const staffSet = new Set(staffServices);

        const mapped = shopServices.map((svc) => ({
            serviceId: svc.serviceId,
            name: svc.name,
            price: svc.price,
            currency: svc.currency,
            duration: svc.duration,
            isHomeService: svc.isHomeService,
            active: staffSet.has(svc.serviceId),
        }));

        setRows(mapped);
    }, [isOpen, shopServices, staffServices]);

    useEffect(() => {
        if (!isOpen) setRows([]);
    }, [isOpen]);

    const updateRow = (index, patch) => {
        setRows((prev) => {
            const next = [...prev];
            next[index] = { ...next[index], ...patch };
            return next;
        });
    };

    const handleSave = async () => {
        const serviceIds = rows.filter((r) => r.active).map((r) => r.serviceId);

        try {
            const res = await companyBasedRequest.updateUserServices(
                userData.user.userId,
                serviceIds,
                userData.cognitoTokens.AccessToken
            );
            setUserData((prev) => ({
                ...prev,
                user: res.user,
            }));
            onSave?.(serviceIds);
        } catch (err) {
            console.error("Failed to save staff services", err);
        }

        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="sf-staff-services-overlay" onClick={onClose}>
            <div className="sf-staff-services-modal" onClick={(e) => e.stopPropagation()}>
                {/* HEADER */}
                <div className="sf-staff-services-header">
                    <h2 className="sf-staff-services-title">
                        {translations[language]?.profile?.services?.title || "My Services"}
                    </h2>
                    <button className="sf-staff-services-close" onClick={onClose}>
                        ✕
                    </button>
                </div>

                {/* BODY */}
                <div className="sf-staff-services-body">
                    {rows.map((row, idx) => (
                        <div key={row.serviceId} className="sf-staff-services-row">
                            <div className="sf-staff-services-left">
                                <div className="sf-staff-services-name">
                                    {row.name}

                                    {row.isHomeService && (
                                        <span className="sf-staff-services-home">
                                            <span className="sf-staff-services-dot"> · </span>
                                            {language === "es" ? "Domicilio" : "Home service"}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="sf-staff-services-right">
                                <div className="sf-staff-services-meta">
                                    <span>
                                        {row.currency} {row.price}
                                    </span>

                                    {/* <span className="sf-staff-services-dot">·</span> */}

                                    <span>{row.duration} min</span>
                                </div>

                                <button
                                    className={`sf-staff-services-toggle ${row.active ? "active" : "inactive"}`}
                                    onClick={() => updateRow(idx, { active: !row.active })}
                                >
                                    {row.active
                                        ? translations[language]?.teamPage?.main?.active || "Active"
                                        : translations[language]?.teamPage?.main?.inactive || "Inactive"}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="sf-staff-services-footer">
                    <button className="sf-staff-services-save" onClick={handleSave}>
                        Save & Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StaffServicesModal;
